import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Table from '../../components/Table/Table'
import {
    requestsTableCols,
    requestsTableColsMobile,
    requestCheckDuplicateCols,
    requestCheckDuplicateColsMobile,
} from '../../helpers/tableUtils'
import useRequest from '../../hooks/useRequest'
import useAuth from '../../hooks/useAuth'
import { getInitialFilters } from '../../helpers/requestsFilters'
import FilterModal from '../../components/FilterModal/FilterModal'
import useScreen from '../../hooks/useScreen'

const RequestTable = ({
    data,
    onFilter,
    title,
    subtitle,
    isInCard,
    filtersLIst,
    tabFilters,
    isCreateRequest = false,
    ...otherProps
}) => {
    const { isMobile, isTablet } = useScreen()
    const { locations, filters, pastRequestsFilters } = useRequest()
    const [filterOpen, setFilterOpen] = useState(false)
    const [hasActiveFilters, setHasActiveFilters] = useState(false)
    const { user } = useAuth()
    const locPrefs = user?.locationPreferences

    const initialFilters =
        tabFilters === 'activeTabFilters' ? filters : pastRequestsFilters
    const allFilters = filtersLIst
        ? filtersLIst
        : getInitialFilters(locPrefs, locations, tabFilters)
    const hasStoreFilters = initialFilters?.length > 0
    const filtersToUse = hasStoreFilters ? initialFilters : allFilters

    const allFiltersIsReady = filtersToUse?.find(
        item => item?.filters?.length > 0 && item?.filterGrupName == 'Location',
    )

    useEffect(() => {
        if (filtersToUse) {
            const hasActiveFilters = filtersToUse.some(group =>
                group.filters.some(filter => filter.checked),
            )
            setHasActiveFilters(hasActiveFilters)
        }
    }, [filtersToUse])

    const smallScreen = isMobile || isTablet

    const colsToUse = isCreateRequest
        ? smallScreen
            ? requestCheckDuplicateColsMobile
            : requestCheckDuplicateCols
        : smallScreen
        ? requestsTableColsMobile
        : requestsTableCols

    return (
        <Table
            isInCard={isInCard}
            selectable={false}
            hasSearch={true}
            columns={colsToUse}
            data={data}
            totalResults={data?.length}
            type="scroll"
            headerTitle={title}
            headerSubtitle={subtitle}
            searchPlaceholder="Search Request"
            actions={[
                !isCreateRequest && allFiltersIsReady && (
                    <FilterModal
                        isSmallScreen
                        key="filterModal"
                        filtersGroup={filtersToUse}
                        open={filterOpen}
                        setOpen={setFilterOpen}
                        onFilter={onFilter}
                        data={data}
                    />
                ),
            ]}
            searchFields={[
                'label',
                'showType',
                'status',
                'statusDescription',
                'assetNameNormalKey',
                'prettyDate',
                'shipToName',
                'address',
                'details',
                'submittedBy',
                'name',
                'formattedDate',
            ]}
            hasActiveFilters={hasActiveFilters}
            {...otherProps}
        />
    )
}

RequestTable.propTypes = {
    data: PropTypes.oneOfType([PropTypes.array, PropTypes.any]),
    onFilter: PropTypes.oneOfType([PropTypes.func, PropTypes.any]),
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
    isInCard: PropTypes.oneOfType([PropTypes.bool, PropTypes.any]),
    getAllRequests: PropTypes.bool,
    filtersLIst: PropTypes.array,
    isCreateRequest: PropTypes.bool,
    tabFilters: PropTypes.string,
}

export default RequestTable
